import API from '../dataApi';

export const getNotices = (derasarId) => API.get('/notices', { params: { derasarId } });
export const getNotice = (id) => API.get(`/notices/${id}`);
const normalizeNoticePayload = (data) => ({
  ...data,
  category: data.category || null,
  expiryDate: data.expiryDate || null,
});
export const createNotice = (data) => API.post('/notices', normalizeNoticePayload(data));
export const updateNotice = (id, data) => API.put(`/notices/${id}`, normalizeNoticePayload(data));
export const deleteNotice = (id) => API.delete(`/notices/${id}`);
export const pinNotice = (id) => API.put(`/notices/${id}/pin`);
